<template>
  <div class="loginContent">
    <div class="logoImgWrapper">
      <img class="logoImg" v-bind:src="logoImg">
    </div>
    <div class="loginContentHeader">
      <img class="loginBackPageArrowImg" v-bind:src="backPageArrowImg" v-on:click="$router.push('/')">
      <span>비밀번호찾기</span>
    </div>
    <div class="loginContentBody">
      <login-input-text v-bind="emailInput" v-on:returnText="getEmail"></login-input-text>
      <div class="loginButtonWrapper">
        <button class="findPwdBtn" v-bind:disabled="setDisable" v-on:click="findPwd">비밀번호찾기</button>
      </div>
    </div>
    <div class="findPwdMsgWrapper">
      <span class="errorMsg" v-if="validText.invalidFormatEmail">* 이메일 형식을 확인해주세요.</span>
      <span class="errorMsg" v-if="validText.noUser">* 존재하지 않는 유저입니다.</span>
      <span class="successMsg">{{successMsg}}</span>
    </div>
  </div>
</template>

<script>
import loginInputText from '../elements/loginInputText.vue'

export default {
  data () {
    return {
      logoImg: require('@/assets/img/logo.png'),
      emailInput: {
        spanText: '이메일',
        placeHolder: '이메일을 입력하세요',
        isPassword: false
      },
      email: '',
      successMsg: '',
      backPageArrowImg: require('@/assets/img/back_page_arrow.png'),
      validText: {
        invalidFormatEmail: false,
        noUser: false
      }
    }
  },
  components: {
    'login-input-text': loginInputText
  },
  methods: {
    getEmail: function (returnText) {
      this.email = returnText
    },
    findPwd: async function () {
      if (this.validCheck(this.email)) {
        try {
          await this.$store.dispatch('findPwdApi', {email: this.email})
          this.successMsg = '비밀번호를 변경할 수 있는 링크를 메일로 송신했습니다.'
        } catch (error) {
          if (error.response.data.status === 412 && error.response.data.exception.includes('NotTargetException')) {
            // 존재하지 않는 유저
            this.validText.noUser = true
          }
        }
      }
    },
    validCheck: function (email) {
      this.validText.invalidFormatEmail = false
      this.validText.noUser = false

      if(!/^[_0-9a-zA-Z-]+@[0-9a-zA-Z-]+(.[_0-9a-zA-Z-]+)*$/.test(email)) {
        this.validText.invalidFormatEmail = true
        return false
      }
      return true
    },
    browserCheck: function () {
      if(this.$browserDetect.isIE) {
        alert('폴라이드는 인터넷 익스플로러(IE) 브라우저를 지원하지 않습니다. 타 브라우저를 이용해주세요.')
        this.$router.push({name: 'signIn'})
      }
    }
  },
  computed: {
    setDisable: function () {
      return (this.email === '')
    }
  },
  created: function () {
    this.browserCheck()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../assets/css/login.css';
.loginContent{
  position: relative;
}

.logoImgWrapper {
  position: absolute;
  left: 0;
  top: -68px;
}

.logoImgWrapper > .logoImg {
  width: 92px;
  height: 23px;
}

.loginContentHeader{
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  height: 32px;
  font-size: 24px;
}

.findPwdMsgWrapper{
  padding: 0;
  width: 400px;
  text-align: right;
}

.findPwdMsgWrapper > .successMsg {
  font-size: 13px;
  color: rgb(0,153,255);
}

.findPwdMsgWrapper > .errorMsg {
  font-size: 13px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/login/views/findPwd.vue